document.addEventListener("DOMContentLoaded", (function () {
	function n(targetElement, container) {
		try {
			const textContent = targetElement.textContent.trim();
			let percentage = null;

			if (textContent.includes("%")) {
				percentage = parseFloat(textContent.replace("%", ""));
			} else {
				// Fallback calculation from prices
				const priceBox = targetElement.closest('.m-price') || targetElement.closest('[id^="MobilePrice-"]');
				if (priceBox) {
					const salePriceEl = priceBox.querySelector('.m-price-item--sale:not(.m\\:visually-hidden)');
					const regularPriceEl = priceBox.querySelector('s.m-price-item, .m-price-item--regular:not(.m\\:visually-hidden)');
					if (salePriceEl && regularPriceEl && salePriceEl !== regularPriceEl) {
						const s = parseFloat(salePriceEl.textContent.replace(/[^\d.]/g, "").replace(",", "."));
						const r = parseFloat(regularPriceEl.textContent.replace(/[^\d.]/g, "").replace(",", "."));
						if (r > s) percentage = Math.round(((r - s) / r) * 100);
					}
				}
			}

			if (percentage !== null && percentage >= 50) {
				if (!container.querySelector(".produkFinalSale")) {
					container.innerHTML = '<div class="inline-flex produkFinalSale">Final Sale - No Returns, Exchanges, or Refunds</div>';
				}
			} else {
				container.innerHTML = "";
			}
		} catch (e) { }
	}

	function setup(el, index) {
		const target = el.closest(".m-price__badges") || el.closest(".m-price") || el;
		const id = `finalSaleContainer-${index}`;
		let container = target.parentNode.querySelector(`#${id}`);
		if (!container) {
			container = document.createElement("div");
			container.id = id;
			container.className = "final-sale-container-wrapper";
			target.parentNode.insertBefore(container, target.nextSibling);
		}

		new MutationObserver(() => n(el, container)).observe(el, { childList: true, subtree: true, characterData: true });
		n(el, container);
	}

	function scan() {
		const elements = document.querySelectorAll('.m-currency--saved, .m-product-tag--sale, [id^="MobilePrice-"]');
		elements.forEach((el, i) => {
			setup(el, i);
		});
	}

	scan();

	// Fast response for Minimog theme events
	if (window.MinimogEvents) {
		MinimogEvents.subscribe('variantChange', scan);
	}

	const observer = new MutationObserver((mutations) => {
		if (mutations.some(m => m.addedNodes.length > 0)) scan();
	});
	observer.observe(document.body, { childList: true, subtree: true });
}));